export const SECTION_REGEX = /Section \d+/gm;

export const LABEL_MAP = {
  Notebook: 'Notes',
  ReadingGame: 'Checks',
  Section: 'Text',
};
